import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkedAlt, faLightbulb, faImages, faUtensils, faTrophy } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "../../css/BotonesHome.css";
import TarjetaDestacada from "./TarjetaDestacada";

const botones = [
    { titulo: "Viajes", ruta: "/viajes", icono: faMapMarkedAlt },
    { titulo: "Ideas", ruta: "/ideas", icono: faLightbulb },
    { titulo: "Galería", ruta: "/galeria", icono: faImages },
    { titulo: "Recetas", ruta: "/recetas", icono: faUtensils },
    { titulo: "Ranking", ruta: "/ranking", icono: faTrophy },
];

const BotonesHome = () => {
    return (
        <Fragment>
            <div className="botones-home">
                {botones.map((btn, index) => (
                    <Link key={index} to={btn.ruta} className="boton-home-card">
                        <FontAwesomeIcon icon={btn.icono} className="boton-icono" />
                        <span>{btn.titulo}</span>
                    </Link>
                ))}
            </div>
            <TarjetaDestacada />
        </Fragment>
    );
};

export default BotonesHome;
